import type { Course, Credential, Language } from '../types/resume';

const uai = 'https://cdn.magicpatterns.com/uploads/vATRunep3qsss7oGaZ2TVT/pasted-image.jpg';
const uchile = 'https://cdn.magicpatterns.com/uploads/diqH3VqMmuPZYdLx3t1TtC/pasted-image.jpg';
const utfsm = 'https://cdn.magicpatterns.com/uploads/6sTVEdkqHb62PHTnM9XzJT/pasted-image.jpg';

export const degrees: Credential[] = [
  { title: 'Master in Business Administration (MBA)', institution: 'Universidad Adolfo Ibáñez', years: '2003 – 2004', logo: uai },
  { title: 'Electronic Engineer', institution: 'Universidad Técnica Federico Santa María', years: '1978 – 1983', logo: utfsm },
];

export const postgraduate: Credential[] = [
  { title: 'Coach for New Business Development', institution: 'Universidad Adolfo Ibáñez', years: '2008', logo: uai },
  { title: 'Post Graduate Degree in Management (DPA)', institution: 'Universidad Adolfo Ibáñez', years: '1992 – 1993', logo: uai },
  { title: 'Post Graduate Degree in Marketing', institution: 'Universidad de Chile', years: '1991', logo: uchile },
];

export const courses: Course[] = [
  { title: 'Intel Sales & Marketing Conference', type: 'Seminar', year: '2006 – 2016' },
  { title: 'The Changeable Organization', type: 'Course', location: 'Buenos Aires', year: '2010' },
  { title: 'Formulating Competitive Strategy and Differentiation', type: 'Course', location: 'Las Vegas, USA', year: '2009' },
  { title: 'Financial Acumen', type: 'Course', location: 'São Paulo', year: '2008' },
  { title: 'Power Base Selling', type: 'Course', location: 'São Paulo', year: '2008' },
  { title: 'Dynamics of Market Development', type: 'Course', location: 'Las Vegas, USA', year: '2008' },
  { title: 'Versatile Sales Person', type: 'Course', location: 'Las Vegas, USA', year: '2008' },
  { title: 'Situational Sales Negotiation', type: 'Course', location: 'Buenos Aires', year: '2007' },
  { title: 'Customer Relationship Management', type: 'Course', location: 'Sun University, Santiago', year: '2004' },
  { title: 'Solution Selling Workshop', type: 'Course', location: 'Sun University, Santiago', year: '2004' },
  { title: 'Datawarehouse Technology', type: 'Seminar', location: 'Denver, USA', year: '1998' },
  { title: 'Visionary Selling', type: 'Course', location: 'Orlando, USA', year: '1998' },
  { title: 'Latin American Telecom Market Solutions Training', type: 'Seminar', location: 'Miami, USA', year: '1997' },
  { title: 'Competitive Selling', type: 'Course', location: 'Sybase University', year: '1997' },
];

export const languages: Language[] = [
  { name: 'English', level: 'Full professional proficiency' },
  { name: 'French', level: 'Elementary proficiency' },
];
